
const scripts = {};

function getScript(url) {
  return scripts[url];
}

function setScript(url, status = {}) {
  scripts[url] = { url, ...status };
  return getScript(url);
}

function load(url, type) {
  return new Promise((res) => {
    const s = document.createElement('script');
    s.onload = () => {
      res();
    };
    s.type = type;
    s.src = url;
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(s);
  });
}

/**
 * Load scripts `<script src="/path/to.js"></script>` into DOM.
 * Avoids duplicate script paths.
*/
export async function loadScript(url, type = 'text/javascript') {
  const script = getScript(url);
  if (script) {
    return script;
  }

  if (document.querySelector(`script[src="${url}"]`)) {
    return setScript(url, {
      loading: false,
      loaded: true,
    });
  }

  setScript(url, {
    loading: true,
    loaded: false,
  });

  await load(url, type);

  return setScript(url, {
    loading: false,
    loaded: true,
  });
}

/**
 * Load scripts `<script src="/path/to.js"></script>` into DOM.
 * Keep trying `loadScript` until a script is successfully loaded into DOM.
*/
export async function loadComplete(url, type = 'text/javascript') {
  const s = await loadScript(url, type);
  if (s && s.loaded) {
    return s;
  }

  return await new Promise((res, rej) => {
    let count = 0;
    const t = setInterval(async () => {
      if (count >= 100) {
        clearInterval(t);
        rej(new Error('Script load limit exceeded'));
        return;
      }
      const ss = await loadScript(url, type);
      if (ss && ss.loaded) {
        clearInterval(t);
        res(ss);
      }
      count += 1;
    }, 100);
  });
}



// WEBPACK FOOTER //
// ./src/utils/scripts.js